export enum UserRole {
  ADMIN = 'ADMIN',
  CONTENT_EDITOR = 'CONTENT_EDITOR',
}

export const UserRoleLabelMap: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Admin',
  [UserRole.CONTENT_EDITOR]: 'Content Editor',
};

export enum UserStatus {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export const UserStatusLabelMap: Record<UserStatus, string> = {
  [UserStatus.INVITED]: 'Invite Sent',
  [UserStatus.ACTIVE]: 'Active',
  [UserStatus.DEACTIVATED]: 'Deactivated',
};
